export default "__VITE_ASSET__DmHtmxAp__"